<div class="row" fxLayout="row">
    <div class="col-6">
        <br>
        <h1 class="title">Usuários do Portal</h1>
        <mat-form-field class="search-field" appearance="outline">
            <mat-icon (click)="pesquisar()" matSuffix>search</mat-icon>
            <input matInput placeholder="Pesquise aqui" [(ngModel)]="search">
        </mat-form-field>
    </div>
    <div class="col-6" style="align-items: flex-end;justify-content: flex-end;margin:20px;">
        <button class="botaoPrimario" mat-raised-button (click)="gerenciarUsuario('add', 0)" fxLayoutAlign="end center">
            Novo Usuário
        </button>
    </div>
</div>

<mat-tab-group animationDuration="0ms">
    <mat-tab>
        <div class="mat-elevation-z4">
            <table mat-table [dataSource]="objAtivos">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>Código do usuário</th>
                    <td mat-cell *matCellDef="let row">{{row.id}}</td>
                </ng-container>

                <ng-container matColumnDef="nome">
                    <th mat-header-cell *matHeaderCellDef>Nome</th>
                    <td mat-cell *matCellDef="let row">{{row.nome}}</td>
                </ng-container>

                <ng-container matColumnDef="razao">
                    <th mat-header-cell *matHeaderCellDef>Login</th>
                    <td mat-cell *matCellDef="let row">{{row.login}}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Ações</th>
                    <td mat-cell *matCellDef="let row; let i = index;">
                        <button class="delete-btn" (click)="gerenciarUsuario('update', row.id)">
                            <mat-icon matTooltipPosition="right" matTooltipClass="allow-cr"
                                matTooltip="Gerenciar Usuario">edit</mat-icon>
                        </button>
                        <mat-slide-toggle [(ngModel)]="this.arrChecked[i]" class="example-margin" [color]="color"
                            (change)="changed($event, row.id)">
                            <span *ngIf="this.arrChecked[i] == true ">Ativo</span>
                            <span *ngIf="this.arrChecked[i] == false">Inativo</span>
                        </mat-slide-toggle>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsAtivos"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsAtivos;"></tr>
            </table>
        </div>
        <mat-paginator [length]="lengthAtivos" [pageSize]="pageSizeAtivos" [pageSizeOptions]="pageSizeOptionsAtivos"
            (page)="pageEvent = clickPageAtivos($event)">
        </mat-paginator>
    </mat-tab>
</mat-tab-group>